import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Text, TextProps } from '../../components/Text'
import { getPricesMode, PricesMode } from '../../redux/config'
import { ContractType } from '../../redux/user'
import { getContractType } from '../../redux/user/selectors'
import { createTFunction } from '../../utils/helpers'

type Props = {
  wrapperProps?: TextProps
}

export const TaxesFootnote = ({ wrapperProps }: Props) => {
  const contractType = useSelector(getContractType)
  const pricesMode = useSelector(getPricesMode)

  const { t } = useTranslation(['core'])
  const tc = createTFunction('core:', t)

  if (pricesMode === PricesMode.WithTaxInfo) return null

  return (
    <Text {...wrapperProps}>
      * {contractType === ContractType.PayperClick ? tc('TaxesFootnote') : tc('TaxesFootnotePrepaid')}
    </Text>
  )
}
